module.exports = __webpack_public_path__ + "static/media/brittany.111244b2.jpeg";